export default "__VITE_ASSET__BZfazQ$r__"